// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1Gd-C","topBottomGutter":"Layout_topBottomGutter__3bWMn"};